
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import iphone from '../../assets/img/iphone.png';
import match from '../../assets/img/match.png';
import chat from '../../assets/img/chat.png';
import like from '../../assets/img/like.png';
import map from '../../assets/img/mapa.png';
import midias from '../../assets/img/Social Media.svg';
import icon from '../../assets/img/icon.svg';
import peaple from '../../assets/img/peaple.svg';
import emoji from '../../assets/img/friendships.svg';
import vector1 from '../../assets/img/vector1dsk.svg';
import vector2 from '../../assets/img/Vector2.png';
import vector3 from '../../assets/img/Vector3.png';
import vector4 from '../../assets/img/Vector4.png';
import vector5 from '../../assets/img/Vector5.png';
import vector6 from '../../assets/img/Vector6.png';
import google from '../../assets/img/boton google play.svg';
import apple from '../../assets/img/boton app store.svg';
import ny from '../../assets/img/nyc.svg';
import arrow from '../../assets/img/arrow.svg';
import estilo from '../../assets/img/background-vector.png';
import background from '../../assets/img/backgroundvector.svg'; // Caminho para a imagem



const Home = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
    <>
    <header className="header-containerx">
        
        <div className="header-left">
            <img className='logo2'src={logo} alt="Logo" height='70px' />
        </div>
        <nav className="header-nav">
            <a href="/">Home</a>
            <a href="/ambassadors">Ambassadors</a>
            <a href="/teamsobr">Team Sobr</a>
            <a href="/terms&policy">Terms and Policy</a>
        </nav>
        <div className="header-right">
        <a className='butontranslate' href="/br">pt-BR</a>
        <a className='butontranslate' href="/es">es-ES</a>
        </div>
    </header>
        <body>
            <div className='div1'>
                <div className="iphone5">
                    <main>
                    <section className="hero2">
                            <h1>Connect with people who are revolutionizing happiness!</h1>
                            <p>Sobr is more than an app - it's a meeting place for those who have chosen a sober lifestyle, full of health and fun.                            </p>                   
                        <br></br>
                        <br></br>
                        <button className="demo-button">FREE BOOK DEMO</button>
                    </section>
                    </main>
                    <img src={iphone} alt="iphone" title="iphone" height="500" />                  
                </div>                
                </div>
                <div className="content2dsk">
                    <img className='match2' src={match} alt="match" title="match" height="500" />  
                    <section>       
                            <h1>Authentic Connections</h1>          
                            <p>Our personalized matchmaking algorithm goes beyond the superficial. We analyze your interests, preferences and behaviors to suggest truly compatible profiles. Make meaningful connections with people who share your values and are committed to sobriety.                            </p>                                    
                    </section>  
                </div>
                <div className="content3dsk">
                    <section>       
                            <h1>Chat with your matches
                            </h1>          
                            <p>Here, communication is safe and private. Use our chat feature to connect with your matches in real time. Share messages, photos and special moments, building genuine and lasting bonds.
                            </p>                                    
                    </section>  
                    <img className='chat' src={chat} alt="chat" title="chat" height="500" />  
                </div>
                <div className='div2'></div>
                <div className="content4dsk">
                    <img className='like2' src={like} alt="like" title="like" height="500" />  
                    <section>       
                            <h1>Show your true essence</h1>          
                            <p>Be yourself! Create an authentic profile that reflects your personality and interests. Attract ideal matches based on your authenticity and compatibility, opening the door to real and meaningful connections.
                            </p>                                    
                    </section>  
                </div>
                <div className='div3'></div>
                <div className="content5dsk">
                    <section className=' divnyc'>       
                            <h1>Discover new places</h1>          
                            <p>Explore the best of sober living with Sobr Places. Discover events, activities and places that are perfect for socializing and meeting new people in your community. Live authentic experiences and strengthen your bonds on the journey to a happier, healthier life.
</p>                                    
                    </section> 
                    
                    <div className='containerdsk'>
                    <img className="map" src={map} alt="map" title="map" height="500" />
                    </div> 
                </div>
                {/*<div className="content6dsk">
                    <h1>Sobr shouldn’t be somber.</h1>
                    <p>We created Sobr with the belief that being sober isn’t the end of the good times, but the start. Here’s our story in a few more words…</p>
                </div>
                <div className='carddsk'>
                <div className="support-carddsk">
                    <div className="peapledsk">
                        <img src={peaple} alt="members" title="members" />
                    </div>
                    <div className="textdsk">
                        <h2>+190.000</h2>
                        <p>members</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="icondsk">
                        <img src={icon} alt="support" title="support" />
                    </div>
                    <div className="textdsk">
                        <h2>+3.3M</h2>
                        <p>Support Messages</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="emojidsk">
                        <img src={emoji} alt="friendships" title="friendships" />
                    </div>
                    <div className="text">
                        <h2>+155,000</h2>
                        <p>friendships</p>
                    </div>
                </div>
                </div>
                <div className='downloaddsk'>
                    <h3> Download the app today! </h3>
                <img className="google3" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className='div4'>
                <div className="content7dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div>
                </div> */}
                
                <footer>
                    <div className="footer-contentdsk">
                        <p>Terms of Service | Privacy Policy</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc. All rights reserved   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Home;
